import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import { showLiveIndicator } from '@services';
import { GlobalContext } from '../GlobalContext';
import LiveIndicator from '../LiveIndicator';

type Props = {
  altText: string
  btnOnclick: any
  image: IGatsbyImageData | null | undefined
  video: any | null
}

function VideoPlayerThumbnail({
  altText, btnOnclick, image, video,
}: Props) {
  const globalContext = React.useContext(GlobalContext);
  return (
    <button type="button" className="relative flex items-center justify-center w-full h-full" onClick={btnOnclick}>
      <span className="absolute bg-[#25252f] opacity-[80%] rounded-[100%] w-[100px] z-10">
        <div className="w-[100px] h-[100px] flex justify-center items-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" data-poster="" className="h-full w-[50px] transform translate-x-1">
            <path fill="#fff" d="M1.425.35L14.575 8l-13.15 7.65V.35z" />
          </svg>
        </div>
      </span>
      {image && (
        <GatsbyImage image={image} alt={altText} className="w-full h-full" />
      )}
      {showLiveIndicator(globalContext?.liveItems, video) && (
        <LiveIndicator />
      )}
    </button>
  );
}

export default VideoPlayerThumbnail;
